import { render } from "./Layout.vue?vue&type=template&id=20ceb7e2&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=20ceb7e2&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ceb7e2"]])

export default __exports__